import React, { useState } from 'react'
import { CallRounded, FacebookRounded, LinkedIn, Mail } from '@mui/icons-material'
import {BackToTop, Email, ImageBuffer} from '../'
import {Name} from '../'
import { logoPng } from '../../assets'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../reducers/store'

import './footer.css'

const Footer = () => {
  const dispatch                    = useDispatch<AppDispatch>();
  const [toggleNav, setToggleNav]   = useState<boolean>(false);

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    setToggleNav(false);

    const element = document.getElementById(id);
    if (element) {
      // const offset = 80; // same as navbar height
      const offset = document.querySelector(".navbar")?.clientHeight || 0;
      const y = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <>
      <footer className='footer'>
        <div className="footer__container">
          <div className='footer__container-right'>
            <div className='footer-shop-logo-container'>
              <div className='footer-shop-logo'>
                <div className='footer-shop-logo-wrapper'>
                  <ImageBuffer src={logoPng} alt='logo' />
                </div>
              </div>
            </div>
            <div className="footer-content">
              <ul className="permalinks">
                <li><a onClick={(e) => handleScroll(e, "hero")} className='menu-link' href="#hero"><span>Home</span></a></li>
                <li><a onClick={(e) => handleScroll(e, "about")} className='menu-link' href="#about"><span>About</span></a></li>
                <li><a onClick={(e) => handleScroll(e, "services")} className='menu-link' href="#services"><span>Services</span></a></li>
              </ul>
              <p className='permalinks-description'>At <Name />, we provide Quality Care,<br/> Delivered With Professional Precision.</p>
            </div>
            <div className="footer-content">
              <h4>Contact us</h4>
              <div className='footer-contact'>
                <a href="tel:+14694340425" className='footer-contact-icon'><CallRounded /> +1 4694340425</a>
                <span className='footer-contact-icon'><Mail /> <Email /></span>
                <ul className="footer__socials">
                  <li><a className='footer__socials_link' href={`https://web.facebook.com/profile.php?id=61587469531383&_rdc=1&_rdr#`} target='_blank' rel="noreferrer"><span><FacebookRounded /></span></a></li>
                  <li><a className='footer__socials_link' href={`https://www.linkedin.com/company/a1-care-home-health/`} target='_blank' rel="noreferrer"><span><LinkedIn /></span></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className='copyright-detail'>&copy; { new Date().getFullYear() } <Name /> | All rights reserved.</div> 
          
          <a className='developer' target='_blank' href="https://www.sanmexm.com">Developed by Oluwasanmi</a>
        </div>
      </footer>
      <BackToTop />
    </>
  )
}

export default Footer